import useFetch from '@hooks/useFetch';
import useGroupsChangeStore from '@stores/groups/groupsChangeStore';
import { useEffect } from 'react';
import { getIsSubscribedToOffline } from '@api/selectors/subscription';
import useGoalInfo from '@api/hooks/goal/useGoalInfo';
import useMyInfo from '@api/hooks/auth/useMyInfo';

const useGroupInfo = (
  goalUID,
  options = { selector: null, fallbackData: undefined }
) => {
  const { isGroupNew } = useGroupsChangeStore();
  const key = `v1/group/info/?goal_uid=${goalUID}`;
  const { goalInfo = {} } = useGoalInfo(goalUID);
  const {
    data: groupInfo,
    isLoading,
    isError,
    mutate
  } = useFetch(
    goalUID && goalInfo.isGroupServiceEnabled ? key : null,
    {},
    { fallbackData: options.fallbackData }
  );

  useEffect(() => {
    mutate();
  }, [isGroupNew, mutate]);

  const isOfflineSubscription = useMyInfo(getIsSubscribedToOffline(goalUID));
  if (!goalInfo.isGroupServiceEnabled)
    return { groupsEnabledStatus: 'disabled' };

  if (isLoading) return { groupsEnabledStatus: 'unknown' };

  if (isError || isOfflineSubscription)
    return { groupsEnabledStatus: 'disabled' };

  const { groupUid } = groupInfo;

  return {
    groupsEnabledStatus: 'enabled',
    groupUID: groupUid
  };
};

export default useGroupInfo;
